/**
 * Provider Brand Icons
 *
 * Official manufacturer logos for each LLM provider type.
 */

import azureOfficialLogo from '../../../assets/provider-logos/azure-official.svg';
import awsOfficialLogo from '../../../assets/provider-logos/aws-official.svg';
import voyageOfficialLogo from '../../../assets/provider-logos/voyage-official.svg';
import vertexAiOfficialLogo from '../../../assets/provider-logos/vertex-ai-official.svg';

interface ProviderIconProps {
  className?: string;
  size?: number;
}

/** Microsoft Azure official logo mark. */
function AzureFoundryIcon({ className = '', size = 24 }: ProviderIconProps) {
  return (
    <img
      src={azureOfficialLogo}
      alt="Microsoft Azure"
      width={size}
      height={size}
      className={className}
    />
  );
}

/** Voyage AI official icon. */
function VoyageIcon({ className = '', size = 24 }: ProviderIconProps) {
  return (
    <img
      src={voyageOfficialLogo}
      alt="Voyage AI"
      width={size}
      height={size}
      className={className}
    />
  );
}

/** Amazon Web Services official logo. */
function AwsBedrockIcon({ className = '', size = 24 }: ProviderIconProps) {
  return (
    <img
      src={awsOfficialLogo}
      alt="Amazon Web Services"
      width={size}
      height={size}
      className={className}
    />
  );
}

/** Google Vertex AI official logo. */
function VertexAiIcon({ className = '', size = 24 }: ProviderIconProps) {
  return (
    <img
      src={vertexAiOfficialLogo}
      alt="Google Vertex AI"
      width={size}
      height={size}
      className={className}
    />
  );
}

/**
 * Default/fallback provider icon.
 */
function DefaultProviderIcon({ className = '', size = 24 }: ProviderIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <path d="M8 12H16M12 8V16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

/** Map of provider type to icon component */
const PROVIDER_ICONS: Record<string, React.FC<ProviderIconProps>> = {
  azure_foundry: AzureFoundryIcon,
  voyage: VoyageIcon,
  aws_bedrock: AwsBedrockIcon,
  vertex_ai: VertexAiIcon,
};

/**
 * Render the appropriate icon for a provider type.
 */
export function ProviderIcon({
  providerType,
  className = '',
  size = 24,
}: ProviderIconProps & { providerType: string }) {
  const IconComponent = PROVIDER_ICONS[providerType] || DefaultProviderIcon;
  return <IconComponent className={className} size={size} />;
}
